export default __webpack_public_path__ + "static/media/galaxy-s25-edge-jetblack.de740375.jpg";